import { EQuestionType, hasLanguageKeyAndStringValue, type TLocalized } from '@hubertai/screening-question-types';
import {
  type TAvailableLanguageCodes,
  defaultMultipleSelectHelpText,
  defaultRankingHelpText,
} from '@hubertai/hubert-component-library';

export type HelpTextResult = {
  text: string;
  isDefault: boolean;
};

type QuestionHelpText = TLocalized<string>;

export function getHelpTextWithDefault(
  questionHelpText: QuestionHelpText | undefined,
  questionLanguage: TAvailableLanguageCodes,
  questionType: EQuestionType,
  rankingMode?: 'dnd' | 'click',
): HelpTextResult {
  if (hasLanguageKeyAndStringValue(questionHelpText ?? {}, questionLanguage)) {
    return {
      text: questionHelpText?.[questionLanguage] ?? '',
      isDefault: false,
    };
  }

  switch (questionType) {
    case EQuestionType.MultipleSelect:
      return {
        text: defaultMultipleSelectHelpText(questionLanguage),
        isDefault: true,
      };
    case EQuestionType.Ranking: {
      const text = defaultRankingHelpText(rankingMode ?? 'click', questionLanguage);
      return {
        text: text,
        isDefault: true,
      };
    }
    default:
      return {
        text: '',
        isDefault: true,
      };
  }
}
